export default "__VITE_ASSET__DnGKJ9g4__"